import { render, staticRenderFns } from "./resultTag.vue?vue&type=template&id=5a1ef4e8&scoped=true&"
import script from "./resultTag.vue?vue&type=script&lang=js&"
export * from "./resultTag.vue?vue&type=script&lang=js&"
import style0 from "./resultTag.vue?vue&type=style&index=0&id=5a1ef4e8&scoped=true&lang=css&"
import style1 from "./resultTag.vue?vue&type=style&index=1&id=5a1ef4e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1ef4e8",
  null
  
)

export default component.exports